<template>
  <div>
    <center>
      <v-img height="100%" :src="imageHeadHRM"></v-img>
      <v-container fluid>
        <v-row dense>
          <v-col>
            <v-card>
              <v-img
                @click="Home()"
                :lazy-src="imageUrlBack"
                max-height="30"
                max-width="100"
                :src="imageUrlBack"
              ></v-img>
            </v-card>
            <p></p>
            <v-alert
              class="text-left"
              dense
              outlined
              type="info"
            >
              โปรดใส่ข้อมูลชุดนี้ตามความเป็นจริง เพื่อให้บริษัทได้ช่วยเหลือท่าน
            </v-alert>
            <v-card>
              <v-card
                class="mx-auto my-2 text-left"
                elevation="12"
                v-for="(items, index) in CovidItem"
                :key="index"
              >
                <v-card-title @click="dialogEdit = true, getDataById(items)">
                  <v-row>
                    <v-col>
                      <b>ขอความช่วยเหลือ</b>
                      <v-chip
                        class="ma-2"
                        color="red"
                        text-color="white"
                      >
                        {{items.covidHelpStatus}}
                      </v-chip>
                    </v-col>
                  </v-row>
                  <v-divider></v-divider>
                  <v-card-text>
                    <div class="text--primary">
                      <v-row>
                        <v-container fluid>
                          <v-chip v-if="items.covidHelpChoice == 'True'"
                            >อาหาร/น้ำดื่ม</v-chip
                          >
                          <v-chip v-if="items.covidHelpChoice1 == 'True'"
                            >ยาสามัญ</v-chip
                          >
                          <v-chip v-if="items.covidHelpChoice2 == 'True'"
                            >ที่พักเฝ้าสำหรับกักตัว</v-chip
                          >
                          <v-chip v-if="items.covidHelpChoice3 == 'True'"
                            >เครื่องวัดอ็อกซิเจน</v-chip
                          >
                          <v-chip v-if="items.covidHelpChoice4 == 'True'"
                            >หน้ากากอนามัย</v-chip
                          >
                          <v-chip v-if="items.covidHelpOther"
                            >อื่นๆ: {{ items.covidHelpOther }}</v-chip
                          >
                        </v-container>
                      </v-row>
                    </div>
                  </v-card-text>
                </v-card-title>
              </v-card>
              <v-row :show="!dataReady">
                <v-col cols="12" sm="6" md="4">
                  <v-btn
                    color="success"
                    dark
                    block
                    x-large
                    @click="dialog = true"
                    >กดเพิ่มขอความช่วยเหลือ<v-icon right dark>
                      mdi-plus-circle
                    </v-icon></v-btn
                  >
                </v-col>
              </v-row>
              <v-dialog v-model="dialogEdit" fullscreen persistent>
                <v-card>
                   <v-container fluid>
                    <v-card-text>
                      <v-row style="height: 35px">
                        <v-card>
                          <br />
                          <v-subheader id="subtext"
                            ><strong
                              >กรณีขอความช่วยเหลือท่านมีความประสงค์ให้ทางบริษัทช่วยเหลือท่านเรื่องใดบ้าง</strong
                            ></v-subheader
                          >
                          <br />
                        </v-card>
                      </v-row>
                      <br />

                      <v-container fluid>
                        <br />
                        <br />
                        <v-checkbox
                          v-model="formUpdate.covidHelpChoice"
                          label="อาหาร/น้ำดื่ม"
                        ></v-checkbox>
                        <v-checkbox
                          v-model="formUpdate.covidHelpChoice1"
                          label="ยาสามัญ"
                        ></v-checkbox>
                        <v-checkbox
                          v-model="formUpdate.covidHelpChoice2"
                          label="ที่พักเฝ้าสำหรับกักตัว"
                        ></v-checkbox>
                        <v-checkbox
                          v-model="formUpdate.covidHelpChoice3"
                          label="เครื่องวัดออกซิเจน "
                        ></v-checkbox>
                        <v-checkbox
                          v-model="formUpdate.covidHelpChoice4"
                          label="หน้ากากอนามัย"
                        ></v-checkbox>
                      </v-container>

                      <v-row style="height: 35px">
                        <v-subheader id="subtext">อื่นๆ</v-subheader>
                      </v-row>
                      <v-row style="height: 50px">
                        <v-col cols="12">
                          <v-textarea
                            v-model="formUpdate.covidHelpOther"
                            auto-grow
                            filled
                            color="deep-purple"
                            placeholder="กรอกสำหรับอื่นๆที่ต้องการ"
                            rows="2"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                      <br />
                    </v-card-text>
                  </v-container>
                  <v-card-actions>
                    <v-btn
                      color="red darken-1"
                      text
                      @click="(dialogEdit = false), deleteData(formUpdate)"
                    >
                      Delete
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="blue darken-1"
                      text
                      @click="dialogEdit = false"
                    >
                      Close
                    </v-btn>

                    <v-btn
                      color="blue darken-1"
                      text
                      @click="(dialogEdit = false), editData(formUpdate)"
                    >
                      Save
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>

              <v-dialog v-model="dialog" fullscreen persistent>
                <v-card>
                  <v-container fluid>
                    <v-card-text>
                      <v-row style="height: 35px">
                        <v-card>
                          <br />
                          <v-subheader id="subtext"
                            ><strong
                              >กรณีขอตวามช่วยเหลือท่านมีความประสงค์ให้ทางบริษัทช่วยเหลือท่านเรื่องใดบ้าง</strong
                            ></v-subheader
                          >
                          <br />
                        </v-card>
                      </v-row>
                      <br />

                      <v-container fluid>
                        <br />
                        <br />
                        <v-checkbox
                          v-model="covidHelpChoice"
                          label="อาหาร/น้ำดื่ม"
                        ></v-checkbox>
                        <v-checkbox
                          v-model="covidHelpChoice1"
                          label="ยาสามัญ"
                        ></v-checkbox>
                        <v-checkbox
                          v-model="covidHelpChoice2"
                          label="ที่พักเฝ้าสำหรับกักตัว"
                        ></v-checkbox>
                        <v-checkbox
                          v-model="covidHelpChoice3"
                          label="เครื่องวัดอ็อกซิเจน"
                        ></v-checkbox>
                        <v-checkbox
                          v-model="covidHelpChoice4"
                          label="หน้ากากอนามัย"
                        ></v-checkbox>
                      </v-container>

                      <v-row style="height: 35px">
                        <v-subheader id="subtext">อื่นๆ</v-subheader>
                      </v-row>
                      <v-row style="height: 50px">
                        <v-col cols="12">
                          <v-textarea
                            v-model="covidHelpOther"
                            auto-grow
                            filled
                            color="deep-purple"
                            placeholder="กรอกสำหรับอื่นๆที่ต้องการ"
                            rows="2"
                          ></v-textarea>
                        </v-col>
                      </v-row>
                      <br />
                    </v-card-text>
                  </v-container>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialog = false">
                      Close
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="addData()">
                      Save
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </center>
  </div>
</template>
<script>
import axios from 'axios'
// import VuetifyLogo from '../logo'
export default {
  components: {
    // VuetifyLogo
  },
  name: 'VaccinHistory',
  beforeCreate () {
    // this.$liff.init({ liffId: this.$liff_info }, function (data) {})
  },
  data () {
    return {
      profile: [],
      imageUrlBack: '',
      imageHeadHRM: '',
      vaccineAdd: '',
      vaccineAddComplete: '',
      CovidItem: [],
      dialog: false,
      dialogEdit: false,
      covidHelpChoice: false,
      covidHelpChoice1: false,
      covidHelpChoice2: false,
      covidHelpChoice3: false,
      covidHelpChoice4: false,
      covidHelpOther: '',
      formUpdate: {
        covidHelpChoice: false,
        covidHelpChoice1: false,
        covidHelpChoice2: false,
        covidHelpChoice3: false,
        covidHelpChoice4: false,
        covidHelpOther: ''
      }
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    this.profile = JSON.parse(localStorage.getItem('liff_info'))
    this.imageUrlBack = require('@/assets/Icon/Back.jpg')
    this.imageHeadHRM = require('@/assets/Icon/HRM.jpg')
    this.vaccineAdd = require('@/assets/Icon/vaccineAdd.png')
    this.vaccineAddComplete = require('@/assets/Icon/วัคซีนเข็มที่8.png')

    this.getDataCovidHelp()
  },
  methods: {
    Home () {
      this.$router.push('/Liff/Home')
    },
    async getDataCovidHelp () {
      this.dataReady = false
      this.CovidItem = []

      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/covid_help/get?empCode=" + this.profile.empCode + '&covidHelpStatus=รอดำเนินการ'
        )
        .then(async (response) => {
          this.CovidItem = response.data
          console.log(this.CovidItem)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.CovidItem = []
          this.dataReady = true
        })
    },
    async getDataById (ds) {
      this.dialogEdit = true
      this.formUpdate = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/covid_help/getID?covidHelpId=" + ds.covidHelpId
        )
        .then(async (response) => {
          console.log(response.data)
          this.formUpdate = response.data
          // eslint-disable-next-line no-unneeded-ternary
          this.formUpdate.covidHelpChoice = (this.formUpdate.covidHelpChoice === 'True' ? true : false)
          // eslint-disable-next-line no-unneeded-ternary
          this.formUpdate.covidHelpChoice1 = (this.formUpdate.covidHelpChoice1 === 'True' ? true : false)
          // eslint-disable-next-line no-unneeded-ternary
          this.formUpdate.covidHelpChoice2 = (this.formUpdate.covidHelpChoice2 === 'True' ? true : false)
          // eslint-disable-next-line no-unneeded-ternary
          this.formUpdate.covidHelpChoice3 = (this.formUpdate.covidHelpChoice3 === 'True' ? true : false)
          // eslint-disable-next-line no-unneeded-ternary
          this.formUpdate.covidHelpChoice4 = (this.formUpdate.covidHelpChoice4 === 'True' ? true : false)
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('error function getDataById : ', error)
        })
    },
    async editData (ds) {
      console.log(ds)

      let dt = {
        covidHelpChoice: this.formUpdate.covidHelpChoice,
        covidHelpChoice1: this.formUpdate.covidHelpChoice1,
        covidHelpChoice2: this.formUpdate.covidHelpChoice2,
        covidHelpChoice3: this.formUpdate.covidHelpChoice3,
        covidHelpChoice4: this.formUpdate.covidHelpChoice4,
        covidHelpOther: this.formUpdate.covidHelpOther,
        LAST_USER: this.profile.userName
      }
      console.log(ds)
      if (this.formUpdat.covidHelpChoice === true || this.formUpdat.covidHelpChoice1 === true || this.formUpdat.covidHelpChoice2 === true || this.formUpdat.covidHelpChoice3 === true || this.formUpdat.covidHelpChoice4 === true || this.formUpdat.covidHelpOther !== '') {
        await axios
          .post(
          // eslint-disable-next-line quotes
            this.DNS_IP + "/covid_help/edit/" + ds.covidHelpId,
            dt
          )
          .then(async (response) => {
            console.log(response)
            this.getDataCovidHelp()
          })
        // eslint-disable-next-line handle-callback-err
          .catch((error) => {
            console.log('error function addDataGlobal : ', error)
          })
      }
    },
    async deleteData (item) {
      console.log(item)
      let dt = {
        LAST_USER: this.profile.userName
      }
      console.log(dt)
      await axios
        .post(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/covid_help/delete/" + item.covidHelpId,
          dt
        )
        .then(async (response) => {
          console.log(response)
          this.getDataCovidHelp()
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log('error function deleteData : ', error)
        })
    },
    async addData () {
      let ds = {
        empCode: this.profile.empCode,
        covidHelpChoice: this.covidHelpChoice,
        covidHelpChoice1: this.covidHelpChoice1,
        covidHelpChoice2: this.covidHelpChoice2,
        covidHelpChoice3: this.covidHelpChoice3,
        covidHelpChoice4: this.covidHelpChoice4,
        covidHelpOther: this.covidHelpOther
      }
      console.log(ds)

      if (this.covidHelpChoice === true || this.covidHelpChoice1 === true || this.covidHelpChoice2 === true || this.covidHelpChoice3 === true || this.covidHelpChoice4 === true || this.covidHelpOther !== '') {
        await axios
          .post(
          // eslint-disable-next-line quotes
            this.DNS_IP + "/covid_help/add",
            ds
          )
          .then(async (response) => {
            this.dialog = false
            console.log(response)
            this.linenotify(ds)
            this.getDataCovidHelp()
          })
        // eslint-disable-next-line handle-callback-err
          .catch((error) => {
            console.log('error function addDataGlobal : ', error)
          })
      }
    },
    async linenotify (dt) {
      await axios
        .get(
        // eslint-disable-next-line quotes
          this.DNS_IP + "/line_notify_covid/get?notifyCovidType=แจ้งเตือนขอความช่วยเหลือ",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          // console.log(response.data.captionName)
          response.data.forEach(async data => {
            console.log(data.notifyCovidToken)

            dt.covidHelpChoice = dt.covidHelpChoice === true ? '✅' : '🚫'
            dt.covidHelpChoice1 = dt.covidHelpChoice1 === true ? '✅' : '🚫'
            dt.covidHelpChoice2 = dt.covidHelpChoice2 === true ? '✅' : '🚫'
            dt.covidHelpChoice3 = dt.covidHelpChoice3 === true ? '✅' : '🚫'
            dt.covidHelpChoice4 = dt.covidHelpChoice4 === true ? '✅' : '🚫'

            const today = new Date()
            const time = today.getHours() + ':' + today.getMinutes()
            var massageNoti = 'พบผู้ขอความช่วยเหลือ' +
            '\n\nชื่อผู้ประเมิน : ' + this.profile.empFull_NameTH +
            '\nแผนก : ' + this.profile.masDepartmentName +
            '\nสาขา : ' + this.profile.masBranchName +
            '\nบริษัท : ' + this.profile.masCompanyName +
            '\nเบอร์โทรศัพท์ติดต่อ : ' + this.profile.empTel +
            '\nวันที่ประเมิน : ' + 'วันที่ ' + today.getDate() + '/' + (today.getMonth() + 1) + '/' + today.getFullYear() + ' เวลา ' + time +
            '\n รายการขอความช่วยเหลือ:' +
            '\n อาหาร/น้ำดื่ม: ' + dt.covidHelpChoice +
            '\n ยาสามัญ: ' + dt.covidHelpChoice1 +
            '\n ที่พักเฝ้าสำหรับกักตัว: ' + dt.covidHelpChoice2 +
            '\n เครื่องวัดออกซิเจน :' + dt.covidHelpChoice3 +
            '\n หน้ากากอนามัย: ' + dt.covidHelpChoice4 +
            '\n อื่นๆ: ' + dt.covidHelpOther

            var ds = {
              token: data.notifyCovidToken,
              message: massageNoti
            }

            await axios
              .post(
                // eslint-disable-next-line quotes
                this.DNS_IP + "/line/hrm_notify",
                ds, {
                  headers: {
                    'Application-Key': localStorage.getItem('ApplicationKey')
                  }
                }
              )
              .then(async (response) => {
                console.log(response)
              })
            // eslint-disable-next-line handle-callback-err
              .catch((error) => {
                console.log('linenotify: ', error)
              })
          })
        })
      // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
          console.log(error)
        })
    }
  }
}
</script>
<style scoped>
.table-header {
  background-color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/Liff/CovidAddHelp.vue